import React from 'react';
import { TextButton } from '@wix/design-system';
import { appsSectionDataHooks } from './data-hooks';
import { useEssentials } from '../../contexts/essentials-context';

export interface OnMarketClickProps {
  href?: string;
  onClick: () => void;
}

export function OnMarketClick({ href, onClick }: OnMarketClickProps) {
  const { t } = useEssentials();

  return (
    <TextButton
      href={href}
      underline="onHover"
      as="a"
      size="tiny"
      weight="normal"
      dataHook={appsSectionDataHooks.button}
      onClick={(e) => {
        onClick();
        e.preventDefault();
      }}
    >
      {t('apps.section.on.market.button')}
    </TextButton>
  );
}
